import { LiliNumberInput, LiliTextInput } from '@lili/lili-frontend-common';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { OwnersCenterFormType } from '../OwnersCenterForm/OwnersCenterForm.types';
import { ControllerWrapper } from '@Hooks/index';
import { useBoundStore } from '@Store/useBoundStore';
import { OnboardingFormFields } from '@Types/types';

export interface OwnerPercentageProps {
  control: Control<OwnersCenterFormType>;
  mainOwnerPercentageError: string | undefined;
}

export const OwnerPercentage = (props: OwnerPercentageProps) => {
  const { control, mainOwnerPercentageError } = props;
  const { t } = useTranslation();
  const { firstName, lastName } = useBoundStore((state) => state.customer.customerData);
  return (
    <div className='flex w-full flex-col border-b-[1px] border-b-outline-primary-bw-03 justify-start'>
      <div className='flex w-full items-start sm:gap-[14px] flex-col sm:flex-row'>
        <div className='w-full flex-1 basis-[70%]'>
          <LiliTextInput
            onChange={() => {}}
            id='elPOwnerFullName'
            title={t('pages.ownersCenter.owner', { index: 1 })}
            errorMessage={mainOwnerPercentageError}
            disabled
            value={`${firstName} ${lastName}`}
          />
        </div>
        <div className='w-full flex-1 basis-[30%]'>
          <ControllerWrapper name={OnboardingFormFields.OWNER_PERCENTAGE} control={control}>
            {({ value, onChange, onBlur }) => (
              <LiliNumberInput
                onChange={onChange}
                id={OnboardingFormFields.OWNER_PERCENTAGE}
                title={t('pages.ownersCenter.ownership')}
                onBlur={onBlur}
                value={value}
                min={0}
                max={100}
                suffix='%'
                maxLength={3}
              />
            )}
          </ControllerWrapper>
        </div>
      </div>
    </div>
  );
};
